var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.5C18.3125 37.5 14.7656 36.0469 11.8594 33.1406C8.95312 30.2344 7.5 26.6875 7.5 22.5C7.5 18.3125 8.95312 14.7656 11.8594 11.8594C14.7656 8.95312 18.3125 7.5 22.5 7.5C24.6562 7.5 26.7188 7.94531 28.6875 8.83594C30.6562 9.72656 32.3438 11 33.75 12.6562V7.5H37.5V20.625H24.375V16.875H32.25C31.25 15.125 29.8828 13.75 28.1484 12.75C26.4141 11.75 24.5312 11.25 22.5 11.25C19.375 11.25 16.7188 12.3438 14.5312 14.5312C12.3438 16.7188 11.25 19.375 11.25 22.5C11.25 25.625 12.3438 28.2812 14.5312 30.4688C16.7188 32.6562 19.375 33.75 22.5 33.75C24.9062 33.75 27.0781 33.0625 29.0156 31.6875C30.9531 30.3125 32.3125 28.5 33.0938 26.25H37.0312C36.1562 29.5625 34.375 32.2656 31.6875 34.3594C29 36.4531 25.9375 37.5 22.5 37.5Z",
    fill: "#1D4ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.307c2c405e4f14459f8d5ecc2610a243.svg";
export { ForwardRef as ReactComponent };